import type { ExternalSiteType } from "../types/site";
import { createExternalSitesManager } from "./manager";
import cafe24 from "./sites/cafe24";
import godomall from "./sites/godomall";
import imweb from "./sites/imweb";
import makeshop from "./sites/makeshop";
import naverSmartstore from "./sites/naver-smartstore";
import oopy from "./sites/oopy";
import shopby from "./sites/shopby";
import shopbyPro from "./sites/shopby-pro";
import shopify from "./sites/shopify";
import sixshop from "./sites/sixshop";
import sixshopPro from "./sites/sixshop-pro";
import wix from "./sites/wix";
import wordpress from "./sites/wordpress";

const ExternalSitesManager = createExternalSitesManager();

export const externalSites: (ExternalSiteType | null)[] = [
  "CAFE24",
  "GODOMALL",
  "IMWEB",
  "MAKESHOP",
  "NAVER_SMARTSTORE",
  "OOPY",
  "SHOPIFY",
  "SIXSHOP",
  "SIXSHOP_PRO",
  "SHOPBY",
  "SHOPBY_PRO",
  "WIX",
  "WORDPRESS",
  null,
];

ExternalSitesManager.register(oopy);
ExternalSitesManager.register(sixshop);
ExternalSitesManager.register(sixshopPro);
ExternalSitesManager.register(makeshop);
ExternalSitesManager.register(imweb);
ExternalSitesManager.register(cafe24);
ExternalSitesManager.register(shopify);
ExternalSitesManager.register(wix);
ExternalSitesManager.register(shopby);
ExternalSitesManager.register(shopbyPro);
ExternalSitesManager.register(godomall);
ExternalSitesManager.register(wordpress);
ExternalSitesManager.register(naverSmartstore);

export default ExternalSitesManager;
